/* =========================================================
   MT · "Noche mágica" — interacciones y animaciones
   Vanilla JS, sin librerías. Cada init comprueba si su
   elemento existe, así el archivo sirve en todas las páginas.
   ========================================================= */
(function () {
  'use strict';
  if (window.mtCargado) return;
  window.mtCargado = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esTactil = window.matchMedia('(hover: none)').matches;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  if (enEditor) document.documentElement.classList.add('mt-editor');

  /* ---------- Utilidades ---------- */
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var tareasScroll = [];
  var pendiente = false;
  function alScroll(fn) { tareasScroll.push(fn); fn(); }
  function correrScroll() {
    pendiente = false;
    for (var i = 0; i < tareasScroll.length; i++) tareasScroll[i]();
  }
  window.addEventListener('scroll', function () {
    if (!pendiente) { pendiente = true; requestAnimationFrame(correrScroll); }
  }, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(correrScroll); });

  /* ---------- Titulares palabra a palabra ---------- */
  function partirEnPalabras(el) {
    if (el.dataset.mtPartido) return;
    el.dataset.mtPartido = '1';
    var i = 0;
    (function recorrer(nodo) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
        if (hijo.nodeType === 3) {
          var partes = hijo.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          partes.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'mt-palabra';
            var s = document.createElement('span');
            s.textContent = p;
            s.style.setProperty('--i', i++);
            w.appendChild(s);
            frag.appendChild(w);
          });
          nodo.replaceChild(frag, hijo);
        } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
          recorrer(hijo);
        }
      });
    })(el);
  }

  /* ---------- Reveals con un solo IntersectionObserver ---------- */
  var observador = null;
  function initReveal(ctx) {
    $all('.mt-split', ctx).forEach(partirEnPalabras);
    $all('[data-mt-stagger]', ctx).forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-mt-stagger'), 10) || 90;
      $all('[data-mt-reveal]', grupo).forEach(function (el, idx) {
        el.style.setProperty('--mt-delay', idx * paso + 'ms');
      });
    });
    var elementos = $all('[data-mt-reveal], .mt-split', ctx);
    if (reduceMotion || enEditor || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Nieve en canvas ---------- */
  function initNieve(ctx) {
    if (reduceMotion) return;
    $all('canvas[data-mt-nieve]', ctx).forEach(function (canvas) {
      if (canvas.dataset.mtIniciado) return;
      canvas.dataset.mtIniciado = '1';
      var c = canvas.getContext('2d');
      var cantidad = parseInt(canvas.getAttribute('data-cantidad'), 10) || 70;
      var velocidad = (parseInt(canvas.getAttribute('data-velocidad'), 10) || 5) / 5;
      var copos = [], ancho = 0, alto = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), visible = true;
      function medir() {
        ancho = canvas.offsetWidth; alto = canvas.offsetHeight;
        canvas.width = ancho * dpr; canvas.height = alto * dpr;
        c.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function nuevo(arriba) {
        var r = Math.random();
        return {
          x: Math.random() * ancho, y: arriba ? -10 : Math.random() * alto,
          r: 0.6 + r * 2.2, vy: (0.25 + r * 0.7) * velocidad, fase: Math.random() * 6.28,
          amp: 0.3 + Math.random() * 0.6, a: 0.25 + r * 0.6
        };
      }
      medir();
      var n = window.innerWidth < 750 ? Math.round(cantidad * 0.55) : cantidad;
      for (var i = 0; i < n; i++) copos.push(nuevo(false));
      window.addEventListener('resize', medir);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(canvas);
      }
      (function bucle(t) {
        requestAnimationFrame(bucle);
        if (!visible) return;
        c.clearRect(0, 0, ancho, alto);
        for (var i = 0; i < copos.length; i++) {
          var p = copos[i];
          p.y += p.vy; p.x += Math.sin(t / 1600 + p.fase) * p.amp * 0.4;
          if (p.y > alto + 10) copos[i] = nuevo(true);
          c.beginPath();
          c.fillStyle = 'rgba(255,246,228,' + p.a + ')';
          c.shadowColor = 'rgba(255,230,180,.8)'; c.shadowBlur = p.r * 3;
          c.arc(p.x, p.y, p.r, 0, 6.283);
          c.fill();
        }
      })(0);
    });
  }

  /* ---------- Hero: parallax + brillo que sigue al cursor ---------- */
  function initHero(ctx) {
    $all('.mt-hero', ctx).forEach(function (hero) {
      if (hero.dataset.mtIniciado) return;
      hero.dataset.mtIniciado = '1';
      var media = hero.querySelector('.mt-hero__media picture') || hero.querySelector('.mt-hero__media img');
      var intensidad = (parseInt(hero.getAttribute('data-parallax'), 10) || 0) / 100;
      if (media && intensidad && !reduceMotion) {
        alScroll(function () {
          var r = hero.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          media.style.transform = 'translate3d(0,' + (-r.top * intensidad).toFixed(1) + 'px,0)';
        });
      }
      if (!esTactil) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetico(ctx) {
    if (esTactil || reduceMotion) return;
    $all('[data-mt-magnetico]', ctx).forEach(function (b) {
      if (b.dataset.mtIniciado) return;
      b.dataset.mtIniciado = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.3;
        b.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Escaparate sticky ---------- */
  function initEscaparate(ctx) {
    $all('[data-mt-escaparate]', ctx).forEach(function (sec) {
      if (sec.dataset.mtIniciado) return;
      sec.dataset.mtIniciado = '1';
      var pasos = $all('.mt-escaparate__paso', sec);
      var imgs = $all('.mt-escaparate__img', sec);
      var barras = $all('.mt-escaparate__progreso span', sec);
      function activar(idx) {
        pasos.forEach(function (p, i) { p.classList.toggle('is-activa', i === idx); });
        imgs.forEach(function (p, i) { p.classList.toggle('is-activa', i === idx); });
        barras.forEach(function (p, i) { p.classList.toggle('is-activa', i <= idx); });
      }
      activar(0);
      alScroll(function () {
        var centro = window.innerHeight * 0.5, mejor = 0;
        pasos.forEach(function (p, i) { if (p.getBoundingClientRect().top < centro) mejor = i; });
        activar(mejor);
      });
    });
  }

  /* ---------- Techo: linterna que revela la proyección ---------- */
  function initTecho(ctx) {
    $all('[data-mt-techo]', ctx).forEach(function (esc) {
      if (esc.dataset.mtIniciado) return;
      esc.dataset.mtIniciado = '1';
      var radio = parseInt(esc.getAttribute('data-radio'), 10) || 230;
      esc.style.setProperty('--r', radio + 'px');
      var tx = 0.5, ty = 0.5, x = 0.5, y = 0.5, manual = false, temporizador, visible = true;
      if (!esTactil) {
        esc.addEventListener('pointermove', function (e) {
          var r = esc.getBoundingClientRect();
          tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height; manual = true;
          clearTimeout(temporizador);
          temporizador = setTimeout(function () { manual = false; }, 2500);
        });
        esc.addEventListener('pointerleave', function () { manual = false; });
      } else {
        esc.addEventListener('touchmove', function (e) {
          var r = esc.getBoundingClientRect(), t = e.touches[0];
          tx = (t.clientX - r.left) / r.width; ty = (t.clientY - r.top) / r.height; manual = true;
          clearTimeout(temporizador);
          temporizador = setTimeout(function () { manual = false; }, 2500);
        }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(esc);
      }
      (function bucle(t) {
        requestAnimationFrame(bucle);
        if (!visible) return;
        if (!manual) {
          var s = t / 1000;
          tx = 0.5 + Math.sin(s * 0.45) * 0.34;
          ty = 0.5 + Math.sin(s * 0.7 + 1) * 0.28;
        }
        var k = reduceMotion ? 1 : 0.08;
        x += (tx - x) * k; y += (ty - y) * k;
        esc.style.setProperty('--x', (x * 100).toFixed(2) + '%');
        esc.style.setProperty('--y', (y * 100).toFixed(2) + '%');
      })(0);
    });
  }

  /* ---------- Pasos: línea que se dibuja con el scroll ---------- */
  function initPasos(ctx) {
    $all('[data-mt-pasos]', ctx).forEach(function (lista) {
      if (lista.dataset.mtIniciado) return;
      lista.dataset.mtIniciado = '1';
      var linea = lista.querySelector('.mt-pasos__linea');
      var pasos = $all('.mt-paso', lista);
      alScroll(function () {
        var r = lista.getBoundingClientRect();
        var p = clamp((window.innerHeight * 0.8 - r.top) / (r.height * 0.7), 0, 1);
        if (linea) linea.style.setProperty('--mt-progreso', p.toFixed(3));
        pasos.forEach(function (paso, i) {
          var umbral = pasos.length > 1 ? i / (pasos.length - 1) : 0;
          paso.classList.toggle('is-hecho', p >= umbral - 0.001 && p > 0);
        });
      });
    });
  }

  /* ---------- Tarjetas con inclinación 3D ---------- */
  function initInclinacion(ctx) {
    if (esTactil || reduceMotion) return;
    $all('[data-mt-inclinar]', ctx).forEach(function (card) {
      if (card.dataset.mtIniciado) return;
      card.dataset.mtIniciado = '1';
      var max = parseInt(card.getAttribute('data-mt-inclinar'), 10) || 6;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.style.transform = 'rotateY(' + ((px - 0.5) * max * 2).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * max * 2).toFixed(2) + 'deg) translateZ(0)';
        card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras(ctx) {
    $all('[data-mt-contar]', ctx).forEach(function (el) {
      if (el.dataset.mtIniciado) return;
      el.dataset.mtIniciado = '1';
      var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
      var dec = (String(el.getAttribute('data-mt-contar')).split('.')[1] || '').length;
      if (reduceMotion || enEditor || !('IntersectionObserver' in window)) { el.textContent = fin.toFixed(dec); return; }
      el.textContent = (0).toFixed(dec);
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = 1800;
        (function paso(t) {
          var k = clamp((t - t0) / dur, 0, 1);
          var ease = 1 - Math.pow(1 - k, 4);
          el.textContent = (fin * ease).toFixed(dec);
          if (k < 1) requestAnimationFrame(paso);
        })(t0);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* ---------- Acordeones con altura animada ---------- */
  function initAcordeones(ctx) {
    $all('details.mt-faq__item', ctx).forEach(function (d) {
      if (d.dataset.mtIniciado) return;
      d.dataset.mtIniciado = '1';
      var sum = d.querySelector('summary'), resp = d.querySelector('.mt-faq__resp');
      if (!sum || !resp || reduceMotion) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.dataset.animando) return;
        d.dataset.animando = '1';
        if (!d.open) {
          d.open = true;
          var h = resp.scrollHeight;
          resp.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.22,1,.36,1)' })
            .onfinish = function () { delete d.dataset.animando; };
        } else {
          var h2 = resp.scrollHeight;
          resp.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.65,0,.35,1)' })
            .onfinish = function () { d.open = false; delete d.dataset.animando; };
        }
      });
    });
  }

  /* ---------- Zoom suave con scroll (cierre) ---------- */
  function initZoomScroll(ctx) {
    if (reduceMotion) return;
    $all('[data-mt-zoom]', ctx).forEach(function (el) {
      if (el.dataset.mtIniciado) return;
      el.dataset.mtIniciado = '1';
      alScroll(function () {
        var r = el.getBoundingClientRect();
        var p = clamp(1 - (r.top + r.height) / (window.innerHeight + r.height), 0, 1);
        el.style.setProperty('--mt-zoom', (1.12 - p * 0.12).toFixed(4));
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral) ---------- */
  function abrirCarrito(respuesta, idVariante) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && respuesta.sections) {
      drawer.classList.remove('is-empty');
      drawer.renderContents({ id: idVariante, sections: respuesta.sections });
      return;
    }
    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.renderContents === 'function' && respuesta.sections) {
      notif.renderContents({ id: idVariante, key: respuesta.items && respuesta.items[0] && respuesta.items[0].key, sections: respuesta.sections });
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function seccionesCarrito() {
    if (document.querySelector('cart-drawer')) return ['cart-drawer', 'cart-icon-bubble'];
    if (document.querySelector('cart-notification')) return ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    return [];
  }
  // CPF brasileño: 11 dígitos con sus dos dígitos verificadores
  function cpfValido(v) {
    var d = v.replace(/\D/g, '');
    if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
    for (var t = 9; t < 11; t++) {
      var s = 0;
      for (var i = 0; i < t; i++) s += Number(d[i]) * (t + 1 - i);
      if ((s * 10) % 11 % 10 !== Number(d[t])) return false;
    }
    return true;
  }
  function initCompra(ctx) {
    $all('[data-mt-cpf]', ctx).forEach(function (c) {
      c.addEventListener('input', function () {
        var d = c.value.replace(/\D/g, '').slice(0, 11);
        c.value = d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
        c.setCustomValidity(d.length === 11 && !cpfValido(d) ? 'CPF inválido. Confira os números.' : '');
      });
    });
    $all('form[data-mt-compra]', ctx).forEach(function (form) {
      if (form.dataset.mtIniciado) return;
      form.dataset.mtIniciado = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        var error = form.querySelector('.mt-compra__error');
        var id = form.querySelector('[name="id"]').value;
        var qEl = form.querySelector('[name="quantity"]');
        var cantidad = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
        var items = [{ id: Number(id), quantity: cantidad }];
        // Producto complementario marcado (venta cruzada)
        form.querySelectorAll('[data-mt-extra]:checked').forEach(function (x) { items.push({ id: Number(x.value), quantity: 1 }); });
        // CPF del destinatario (solo Brasil)
        var cpf = form.querySelector('[data-mt-cpf]');
        if (cpf) items[0].properties = { CPF: cpf.value.replace(/\D/g, '') };
        if (error) error.hidden = true;
        if (boton) boton.classList.add('is-cargando');
        var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: seccionesCarrito(), sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
            abrirCarrito(res.d, id);
            document.dispatchEvent(new CustomEvent('mt:carrito-actualizado'));
          })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.hidden = false; }
          })
          .finally(function () { if (boton) boton.classList.remove('is-cargando'); });
      });
    });
    $all('[data-mt-cantidad]', ctx).forEach(function (w) {
      if (w.dataset.mtIniciado) return;
      w.dataset.mtIniciado = '1';
      var input = w.querySelector('input');
      $all('button', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + (b.getAttribute('data-delta') === '-1' ? -1 : 1);
          input.value = Math.max(1, Math.min(99, v));
          var gemelo = document.querySelectorAll('input[name="quantity"]');
          gemelo.forEach(function (g) { if (g !== input) g.value = input.value; });
        });
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(ctx) {
    $all('[data-mt-galeria]', ctx).forEach(function (gal) {
      if (gal.dataset.mtIniciado) return;
      gal.dataset.mtIniciado = '1';
      var principal = gal.querySelector('.mt-galeria__principal');
      var imgs = $all('.mt-galeria__principal img', gal);
      var minis = $all('.mt-galeria__miniaturas button', gal);
      var actual = 0;
      function ir(i) {
        if (!imgs.length) return;
        actual = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-activa', k === actual); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === actual); });
        if (minis[actual] && minis[actual].scrollIntoView && window.innerWidth < 990) {
          minis[actual].parentNode.scrollTo({ left: minis[actual].offsetLeft - 20, behavior: 'smooth' });
        }
      }
      gal.mtIr = function (idMedia) {
        var k = imgs.findIndex(function (im) { return im.getAttribute('data-media-id') === String(idMedia); });
        if (k > -1) ir(k);
      };
      var inicial = imgs.findIndex(function (im) { return im.classList.contains('is-activa'); });
      ir(inicial > -1 ? inicial : 0);
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var ant = gal.querySelector('[data-mt-anterior]'), sig = gal.querySelector('[data-mt-siguiente]');
      if (ant) ant.addEventListener('click', function (e) { e.stopPropagation(); ir(actual - 1); });
      if (sig) sig.addEventListener('click', function (e) { e.stopPropagation(); ir(actual + 1); });
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      if (!esTactil) {
        principal.addEventListener('click', function () { principal.classList.toggle('is-zoom'); });
        principal.addEventListener('pointermove', function (e) {
          if (!principal.classList.contains('is-zoom')) return;
          var r = principal.getBoundingClientRect();
          imgs[actual].style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        principal.addEventListener('pointerleave', function () { principal.classList.remove('is-zoom'); });
      }
    });
  }

  /* ---------- Variantes ---------- */
  function initVariantes(ctx) {
    $all('[data-mt-variantes]', ctx).forEach(function (cont) {
      if (cont.dataset.mtIniciado) return;
      cont.dataset.mtIniciado = '1';
      var sec = cont.closest('[data-mt-producto]');
      var datos = sec.querySelector('[data-mt-variantes-json]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = sec.getAttribute('data-formato-dinero') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          if (k.indexOf('no_decimals') > -1) return Math.round(c / 100);
          return k.indexOf('comma') > -1 ? coma : n;
        });
      }
      cont.addEventListener('change', function () {
        var elegidas = $all('fieldset', cont).map(function (f) {
          var r = f.querySelector('input:checked'); return r ? r.value : null;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        var botones = $all('[data-mt-boton-compra]', document);
        if (!v) {
          botones.forEach(function (b) { b.disabled = true; var t = b.querySelector('.mt-btn__txt'); if (t) t.textContent = b.getAttribute('data-txt-no-disponible'); });
          return;
        }
        $all('input[name="id"]', document).forEach(function (i) { i.value = v.id; });
        $all('[data-mt-precio]', document).forEach(function (p) { p.textContent = dinero(v.price); });
        $all('[data-mt-precio-antes]', document).forEach(function (p) {
          p.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
          p.hidden = !(v.compare_at_price > v.price);
        });
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('.mt-btn__txt');
          if (t) t.textContent = v.available ? b.getAttribute('data-txt-comprar') : b.getAttribute('data-txt-agotado');
        });
        if (v.featured_media) {
          var gal = sec.querySelector('[data-mt-galeria]');
          if (gal && gal.mtIr) gal.mtIr(v.featured_media.id);
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      });
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function initBarra(ctx) {
    $all('[data-mt-barra]', ctx).forEach(function (barra) {
      if (barra.dataset.mtIniciado) return;
      barra.dataset.mtIniciado = '1';
      var ancla = document.querySelector(barra.getAttribute('data-mt-barra'));
      if (!ancla || !('IntersectionObserver' in window)) return;
      var pie = document.querySelector('.footer, .mt-pie');
      var pasado = false, enPie = false;
      function pintar() { barra.classList.toggle('is-visible', pasado && !enPie); }
      new IntersectionObserver(function (e) {
        pasado = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; pintar();
      }).observe(ancla);
      if (pie) new IntersectionObserver(function (e) { enPie = e[0].isIntersecting; pintar(); }).observe(pie);
    });
  }

  /* ---------- Arranque ---------- */
  function initTodo(ctx) {
    initReveal(ctx); initNieve(ctx); initHero(ctx); initMagnetico(ctx); initEscaparate(ctx);
    initTecho(ctx); initPasos(ctx); initInclinacion(ctx); initCifras(ctx); initAcordeones(ctx);
    initZoomScroll(ctx); initCompra(ctx); initGaleria(ctx); initVariantes(ctx); initBarra(ctx);
    initEntrega(ctx); initPack(ctx);
  }

  /* ---------- Selector 1 unidad / pack 2: sincroniza con la cantidad ---------- */
  function initPack(ctx) {
    $all('[data-mt-pack]', ctx).forEach(function (pack) {
      if (pack.dataset.mtIniciado) return;
      pack.dataset.mtIniciado = '1';
      var form = pack.closest('form');
      var q = form && form.querySelector('[name="quantity"]');
      if (!q && form) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; form.appendChild(q); }
      if (!q) return;
      // La oferta del complemento (capa) solo vale con 1 unidad: con el pack se oculta y se desmarca
      function extraSegunPack() { var n = parseInt(q.value, 10) || 1; $all('.mt-extra[data-ocultar-pack="true"]', form).forEach(function (x) { x.hidden = n >= 2; if (n >= 2) { var c = x.querySelector('input'); if (c) c.checked = false; } }); }
      pack.addEventListener('change', function (e) { if (e.target.dataset.cantidad) q.value = e.target.dataset.cantidad; extraSegunPack(); });
      function sync() { var n = parseInt(q.value, 10) || 1; var r = pack.querySelector('input[data-cantidad="' + (n >= 2 ? 2 : 1) + '"]'); if (r) r.checked = true; extraSegunPack(); }
      q.addEventListener('change', sync); q.addEventListener('input', sync);
      if (form) form.addEventListener('click', function (e) { if (e.target.closest('[data-delta]')) setTimeout(sync, 0); });
    });
  }

  /* ---------- Fecha estimada de entrega (días hábiles desde hoy) ---------- */
  function initEntrega(ctx) {
    $all('[data-mt-entrega]', ctx).forEach(function (el) {
      function sumar(n) { var d = new Date(); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
      var f = function (d) { return d.toLocaleDateString(el.dataset.locale || 'es', { day: 'numeric', month: 'long' }); };
      // [desde] / [hasta] usan los días del editor; [desde:7] / [hasta:12] permiten fijar otros días por idioma
      var txt = (el.dataset.plantilla || '')
        .replace(/\[desde(?::(\d+))?\]/, function (_, n) { return f(sumar(+(n || el.dataset.min) || 5)); })
        .replace(/\[hasta(?::(\d+))?\]/, function (_, n) { return f(sumar(+(n || el.dataset.max) || 8)); });
      var dest = el.querySelector('[data-mt-entrega-texto]'); if (dest) dest.textContent = txt;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  else initTodo(document);
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();

/* Cuenta regresiva en la barra de anuncios: el texto lleva [cuenta:FECHA-ISO] (p. ej. [cuenta:2026-11-05T23:59:59+01:00]).
   Muestra días + HH:MM:SS hasta esa fecha real; al vencer, la cuenta desaparece. */
(function () {
  var dos = function (n) { return (n < 10 ? '0' : '') + n; };
  function iniciar() {
    document.querySelectorAll('.announcement-bar__message').forEach(function (p) {
      if (p.dataset.mtCuenta) return;
      var m = p.innerHTML.match(/\[cuenta:([^\]]+)\]/);
      if (!m) return;
      var fin = new Date(m[1]).getTime();
      if (isNaN(fin)) return;
      p.dataset.mtCuenta = '1';
      p.innerHTML = p.innerHTML.replace(m[0], '<span class="mt-cuenta" aria-live="off"></span>');
      var el = p.querySelector('.mt-cuenta');
      (function tic() {
        var s = Math.floor((fin - Date.now()) / 1000);
        if (s <= 0) { el.remove(); return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
        el.textContent = (d > 0 ? d + 'd ' : '') + dos(h) + ':' + dos(mi) + ':' + dos(se);
        setTimeout(tic, 1000);
      })();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

/* Lapirum · cuenta regresiva del Black Friday (snippet al-urgencia): data-al-fin="FECHA-ISO". Al vencer se oculta. */
(function () {
  var dos = function (n) { return (n < 10 ? '0' : '') + n; };
  function iniciar() {
    document.querySelectorAll('[data-al-fin]').forEach(function (c) {
      if (c.dataset.alIniciado) return;
      var fin = new Date(c.dataset.alFin).getTime();
      if (isNaN(fin)) return;
      c.dataset.alIniciado = '1';
      (function tic() {
        var s = Math.floor((fin - Date.now()) / 1000);
        if (s <= 0) { c.hidden = true; return; }
        c.hidden = false;
        c.querySelector('[data-d]').textContent = Math.floor(s / 86400);
        c.querySelector('[data-h]').textContent = dos(Math.floor(s % 86400 / 3600));
        c.querySelector('[data-m]').textContent = dos(Math.floor(s % 3600 / 60));
        c.querySelector('[data-s]').textContent = dos(s % 60);
        setTimeout(tic, 1000);
      })();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  /* el carrito lateral se vuelve a pintar al añadir productos */
  new MutationObserver(iniciar).observe(document.documentElement, { childList: true, subtree: true });
})();
